<mat-radio-group [formControl]="kontroll()">
  <mat-tree [dataSource]="dataSource" [levelAccessor]="nivaa" [trackBy]="trackBy" [attr.aria-labelledby]="ariaLabelledBy()" [attr.aria-label]="ariaLabel()" >

    <!-- template for fil-noder -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding data-testid="dokument">
      <button mat-icon-button disabled class="mat-medium-icon-button"></button>
      @if (erValgbar(node)) {
        <mat-radio-button [value]="node.node" (click)="$event.stopPropagation()">
          <div class="dokument">
            <dokument-format-ikon [mimeinfo]="node.standardFormatMimeinfo"/>
            <span data-testid="navn">{{ node.node.navn }}</span>
          </div>
        </mat-radio-button>
      } @else {
        <div class="dokument ikke-valgbar">
          <dokument-format-ikon [mimeinfo]="node.standardFormatMimeinfo"/>
          <span data-testid="navn">{{ node.node.navn }}</span>
        </div>
      }
    </mat-tree-node>

    <!-- template for mappe-noder -->
    <mat-tree-node *matTreeNodeDef="let node; when: erMappe"
                   matTreeNodeToggle
                   matTreeNodePadding
                   matTreeNodePaddingIndent="33"
                   (expandedChange)="ekspander(node, $event)"
                   class="mappe-node"
                   [class.mappe-node-tom]="node.tom()"
                   data-testid="mappe">
      <button mat-icon-button matTreeNodeToggle class="mat-medium-icon-button" aria-label="Toggle">
        @if (node.laster()) {
          <mat-progress-spinner mode="indeterminate" diameter="20"/>
        } @else {
          <mat-icon class="mat-icon-rtl-mirror">
            {{ node.ekspandert() ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        }
      </button>
      @if (erValgbar(node)) {
        <mat-radio-button [value]="node.node" (click)="$event.stopPropagation()">
          <div class="mappe-kontainer">
            <div class="mappe" data-testid="navn">{{ node.node.navn }}</div>
            @if (node.tom()) {
              <div class="tom">{{ 'mappen er tom'|translate }}</div>
            }
          </div>
        </mat-radio-button>
      } @else {
        <div class="mappe-kontainer ikke-valgbar">
          <div class="mappe" data-testid="navn">{{ node.node.navn }}</div>
          @if (node.tom()) {
            <div class="tom">{{ 'mappen er tom'|translate }}</div>
          }
        </div>
      }
    </mat-tree-node>
  </mat-tree>
</mat-radio-group>
